import { render, staticRenderFns } from "./GosuslugiBanner.vue?vue&type=template&id=3c84dab0"
import script from "./GosuslugiBanner.vue?vue&type=script&lang=js"
export * from "./GosuslugiBanner.vue?vue&type=script&lang=js"
import style0 from "./GosuslugiBanner.vue?vue&type=style&index=0&id=3c84dab0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports